export default "__VITE_ASSET__Bt8tSdir__"